  import React, { useState, useRef, MouseEvent, useEffect } from 'react';
import { SequenceTimeline } from './Sequence';
import { SpeechTurn } from 'interfaces/sessions';
import { PartyRole } from 'interfaces/db';
export type Interval = {
  startTime: number,
  endTime: number
}

type ProgressBarProps = {
    userId?: string 
    currentTime: number
    updateCurrentTime: (percentageComplete: number) => void, 
    endTime?: number
    turns?: SpeechTurn[]
    onMouseUp: () => void
    onMouseDown: () => void
    prospectNotRecorded?: boolean,
    play: boolean
}

  
export const AudioPlayerBar = (props: ProgressBarProps) => {
  const rangeRef = useRef<HTMLDivElement>(null);

  const handleMouseDown = (event: MouseEvent<HTMLDivElement>) => {
    event.preventDefault();
    props.onMouseDown()
    updateRange(event.clientX);
    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
  };

  const handleMouseMove = (event: any) => {
    updateRange(event.clientX);
  };

  const handleMouseUp = () => {
    props.onMouseUp()
    document.removeEventListener('mousemove', handleMouseMove);
    document.removeEventListener('mouseup', handleMouseUp);
  };

  const updateRange = (clientX: number) => {
    if (!rangeRef.current) return;
    const rangeRect = rangeRef.current.getBoundingClientRect();
    const offsetX = clientX - rangeRect.left;
    let percentage = (offsetX / rangeRect.width);
    percentage = Math.min(Math.max(percentage, 0), 1); // Clamp between 0 and 100
    props.updateCurrentTime(percentage);
  };

  const talkTimeHeight = 4
  const bgColor = 'rgb(3, 33, 78)'
  // gap*2 + typography + adjust upwards = extra for downwards
  const lineHeight = 2*8 + 1*14 + 2 + 4

  const element =( 
  <div>
  <div className='flex flex-col gap-0' style={{
    'position': 'absolute',
    'top': '-12px',
  }}>
  <div style={{
    'width': '8px',
    'height': '8px',
    'borderRadius': '50%',
    'backgroundColor': `${bgColor}`,
    'cursor': 'grab',
    'zIndex': '9999999',
    'pointerEvents': 'initial'
  }}
  onMouseDown={handleMouseDown} 
  />
<div style={{
  'position': 'relative',
  'left': '3.5px',
  'top': '-2px',
  'width': '1px',
  'height': `${lineHeight}px`,
  'backgroundColor': `${"black"}`,
  'pointerEvents': 'initial',
  'zIndex': '9999999',
  'cursor': 'grab',
  'opacity': '0.6'
  }}
  onMouseDown={handleMouseDown} 
  />
  <div style={{
    'position': 'relative',
    'top': '-10px',
    'width': '8px',
    'height': '8px',
    'borderRadius': '50%',
    'backgroundColor': `${bgColor}`,
    'cursor': 'grab',
    'zIndex': '9999999',
    'pointerEvents': 'initial'
  }}
  onMouseDown={handleMouseDown} 
  />
  </div>
  </div>
  )
  const position = `calc(${props.endTime ? (100*props.currentTime / props.endTime) : 0}%)`
  return (
    <div className='w-full flex flex-col gap-1 flex-grow'>
      <SequenceTimeline 
      bgColor={bgColor} 
      endTime={props.endTime} 
      lineHeight={talkTimeHeight} 
      userId={props.userId} 
      party={PartyRole.REP} 
      callbackfn={handleMouseDown} 
      turns={props.turns}/>
  
      <div className='w-full flex flex-col'>
        <div
          ref={rangeRef}
          style={{
            width: '100%',
          }}
         >
          
          <div className='relative w-full' style={{'userSelect': 'none'}}>
          <div
            style={{
              width: `${props.endTime ? (100*props.currentTime / props.endTime) : 0}%`,
              height: '100%',
              backgroundColor: `${bgColor}`,
              'overflowX': 'hidden'
            }}
            />
          <MovingVerticalLine element={element}  propsPosition={position}/>
          </div>
          </div>
      </div>
      
      <SequenceTimeline 
      prospectNotRecorded={props.prospectNotRecorded} 
      bgColor={bgColor} 
      endTime={props.endTime} 
      lineHeight={talkTimeHeight} 
      party={PartyRole.PROSPECT} 
      callbackfn={handleMouseDown} 
      turns={props.turns}
      />
    </div>
  );
};


type MovingElementProps = {
  propsPosition: string
  element: JSX.Element
}

const MovingVerticalLine = (props: MovingElementProps) => {
  const [position, setPosition] = useState(props.propsPosition);
  const lineRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const animate = () => {
      // Update the position
      setPosition(props.propsPosition);
      // Call animate again on the next frame
      requestAnimationFrame(animate);
    };

    // Start the animation
    animate();
  }, [props.propsPosition]);


  useEffect(() => {
    const lineElement = lineRef.current;

    if (lineElement) {
      lineElement.style.transform = `translateX(min(calc(100% - 6px), ${position}))`;
    }
  }, [position]);

  return (
    <div className='absolute w-full' style={{'zIndex': '999999',   'pointerEvents': 'none'}} ref={lineRef}>
      {props.element}
    </div>
  );
};